import type { Configuration } from '@azure/msal-browser';
import { PublicClientApplication } from '@azure/msal-browser';

import { CLIENT_ID, TENANT_ID } from '../config';

const config: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: `${window.location.origin}/login`,
  },
  cache: {
    // `localStorage`, so the session is the browser's rather than one tab's:
    // middle-clicking a link, duplicating the tab to compare two users, or
    // opening a second window keeps it. `sessionStorage` scoped the cache to
    // the tab that created it — the tokens and, since MSAL keeps its
    // active-account filter in the same store, the account itself — so a new
    // tab arrived with nobody signed in, `_auth` sent it to `/login`, and the
    // operator clicked through a redirect that Entra, still holding its own
    // session, answered without asking them anything. The whole sign-in was
    // the flash.
    //
    // Not a persistent login, though. msal-browser v5 encrypts what it puts in
    // `localStorage` under a key held in a browser-session cookie, so closing
    // the browser still drops the cache — unless Entra itself issued a
    // keep-me-signed-in token, which is its prompt to give, not our config.
    // Within a session it also mirrors writes over a `BroadcastChannel`, so
    // signing out of one tab takes the others with it.
    //
    // What does change on a shared machine: between two operators the session
    // now outlives the tab, and ending it means signing out.
    cacheLocation: 'localStorage',
  },
};

export const msalInstance = new PublicClientApplication(config);
